<div class="input-group append">
  <input
    type="text"
    class="form-control shadow-none"
    [id]="controlName"
    [name]="controlName"
    autocomplete="off"
    [class.invalid]="valid"
    [value]="displayValue"
    ngbDatepicker
    #dp="ngbDatepicker"
    [readonly]="readonly"
    (dateSelect)="onDateSelect($event)"
    [minDate]="ngbMinDate!"
    [maxDate]="ngbMaxDate!"
    [startDate]="startDate!"
    (click)="dp.toggle()"
    container="body"
  />
  <div class="input-group-append" (click)="dp.toggle()">
    <svg-icon
      class="icon-input-group p-2"
      [src]="'./assets/images/icons/calendar.svg'"
    ></svg-icon>
  </div>
</div>
